module.exports = __webpack_public_path__ + "static/media/fading_light_small.35ab8965.jpg";